import { getTables } from "services"
import * as types from "../types/kitchenTables"

export const fetchKitchenTables = (branchId) => (
  async (dispatch) => {
    try {
      const response = await getTables({ branchId })

      dispatch({
        type: types.FETCH_KITCHEN_TABLES,
        tables: response
      })
    } catch (err) {
      console.log(err)
    }
  }
)

export const addKitchenTable = (newTable) => ({
  type: types.ADD_KITCHEN_TABLE,
  newTable
})

export const editKitchenTable = (tableId, newTable) => ({
  type: types.EDIT_KITCHEN_TABLE,
  tableId,
  newTable
})

export const removeKitchenTable = (tableId) => ({
  type: types.REMOVE_KITCHEN_TABLE,
  tableId
})